module.exports = __webpack_public_path__ + "static/media/money.7fda937b.png";